/**
 * ID 生成 / タイムスタンプの共通ユーティリティ。
 *
 * 各ストア (propertyStore / propertyStoreV2 / smokingStore) と
 * setup-map で重複していた実装を集約したもの。
 */

/** 現在時刻の ISO 8601 文字列 (createdAt / updatedAt 用)。 */
export function nowIso(): string {
  return new Date().toISOString();
}

/**
 * 一意 ID を生成する。
 *
 * crypto.randomUUID が使えれば UUIDv4 (プレフィックスなし) を返す。
 * 使えない環境でのフォールバックは `${Date.now()}_${乱数}` 形式で、
 * `prefix` を渡すと `${prefix}_` が先頭に付く (フォールバック時のみ)。
 *
 * UUID にも常にプレフィックスを付けたい場合は呼び出し側で
 * `` `${prefix}_${generateId()}` `` とすること。
 */
export function generateId(prefix?: string): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID();
  }
  const body = `${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
  return prefix ? `${prefix}_${body}` : body;
}
